var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfilePicture(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 180,
    viewBox: "0 0 240 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M120.157 177.75C169.139 177.75 208.846 138.043 208.846 89.0614C208.846 40.08 169.139 0.372803 120.157 0.372803C71.176 0.372803 31.4688 40.08 31.4688 89.0614C31.4688 138.043 71.176 177.75 120.157 177.75Z",
    fill: "#E6E6E6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M131.997 48.3556C131.997 48.3556 134.568 60.7499 133.45 69.3256C133.341 70.1569 133.068 70.9583 132.648 71.6837C132.228 72.4091 131.668 73.0441 131.001 73.5521C130.334 74.0601 129.573 74.431 128.762 74.6434C127.951 74.8559 127.106 74.9057 126.276 74.7899C121.968 74.1728 116.311 72.0642 114.126 65.5971L109.06 55.0542C109.06 55.0542 106.128 48.3428 112.608 42.4028C119.088 36.4628 130.801 40.7185 131.997 48.3556Z",
    fill: "#F4A28C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M109.982 56.97L108.336 98.4343L131.247 97.7014L123.237 67.8214L109.982 56.97Z",
    fill: "#F4A28C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M128.997 49.2429C125.128 49.8531 121.203 50.017 117.297 49.7315C118.622 51.3049 119.457 53.2319 119.699 55.2746C119.941 57.3173 119.58 59.3862 118.66 61.2258C117.805 63.0282 116.349 64.4765 114.542 65.3213C112.736 66.1661 110.691 66.3546 108.76 65.8543L107.05 49.6801C106.722 47.3731 107.027 45.0204 107.933 42.8736C108.839 40.7267 110.311 38.8664 112.193 37.4915C113.815 36.2965 115.511 35.2057 117.271 34.2258C121.707 31.8086 128.843 34.0972 132.7 30.4715C133.082 30.1081 133.553 29.8503 134.065 29.7233C134.577 29.5964 135.113 29.6045 135.621 29.7471C136.129 29.8897 136.592 30.1617 136.963 30.5366C137.334 30.9115 137.602 31.3764 137.74 31.8858C139.025 36.7072 139.09 44.5501 132.764 48.0215C131.585 48.6352 130.312 49.048 128.997 49.2429Z",
    fill: "#24285B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M119.909 60.6985C119.909 60.6985 119.24 55.8643 115.64 56.6743C112.04 57.4843 112.979 64.4657 117.993 64.53L119.909 60.6985Z",
    fill: "#F4A28C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M133.22 56.25L137.296 60.6729C137.525 60.9248 137.688 61.2303 137.768 61.5614C137.849 61.8925 137.845 62.2386 137.756 62.5677C137.668 62.8967 137.498 63.1983 137.263 63.4446C137.027 63.6909 136.734 63.8741 136.409 63.9771L131.703 65.4557L133.22 56.25Z",
    fill: "#F4A28C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.31,
    d: "M125.273 74.2886C122.372 73.9089 119.645 72.6888 117.43 70.7786C117.43 70.7786 118.715 78.2743 127.805 84.7286L125.273 74.2886Z",
    fill: "#CE8172"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M60.4088 154.607C60.4088 154.607 59.046 98.9357 119.089 96.0557C179.132 93.1757 177.55 157.063 177.55 157.063C177.55 157.063 120.902 208.697 60.4088 154.607Z",
    fill: "#7E7E7E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfilePicture);
export default __webpack_public_path__ + "static/media/profile_picture.e1521a5f8e5e33176e6c279ff283f815.svg";
export { ForwardRef as ReactComponent };